import { render, staticRenderFns } from "./AgreementInfo.vue?vue&type=template&id=12614f84&scoped=true&"
import script from "./AgreementInfo.vue?vue&type=script&lang=ts&"
export * from "./AgreementInfo.vue?vue&type=script&lang=ts&"
import style0 from "./AgreementInfo.vue?vue&type=style&index=0&id=12614f84&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12614f84",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VSimpleTable})
